export class AuctionsRoutingNames {
    public static readonly NAME_BASE = '';
    public static readonly NAME_AUCTIONS = 'auctions';

    public static readonly ROUTE_BASE = `/${AuctionsRoutingNames.NAME_BASE}`;
    public static readonly ROUTE_AUCTIONS = `/${AuctionsRoutingNames.NAME_AUCTIONS}`;
}
